import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { configureAuth } from '@crestrewards/api-client';

import App from './App';
import './index.css';

// Point the shared client at THIS app's auth routes, before anything renders.
// Stated explicitly in both apps rather than leaning on the default, so a
// missing call here is a visible omission and not a silent fallback to the
// other app's endpoints. This is the Super Admin console.
configureAuth({ basePath: '/superadmin/auth' });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
